import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import usePersistedState from 'hooks/usePersistedState';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import Snowfall from 'react-snowfall';
import { WL_CONFIG, IS_CHRISTMAS_TIME } from 'constants';
import SelectOrganization from './select-organization';
import {
  sidebar,
  sidebarBottomMenu,
  sidebarItemsContainer,
  sidebarLogo,
  sidebarScrollableSection,
  sidebarTopContainer,
  sidebarTrigger,
  sidebarTriggerIcon,
} from './styles';
import useSideBarItems from './useSideBarItems';
import './index.css';

function Sidebar({ collapsed, setCollapsed, style = {} }) {
  const { bottomItems, topItems, itemsMap, isPlatform } = useSideBarItems(collapsed);
  const navigate = useNavigate();
  const location = useLocation();
  const [openKeys, setOpenKeys] = usePersistedState(
    [],
    'sidebar/open-keys',
  );
  const [currentPath, setCurrentPath] = useState(
    location.pathname === '/' || location.pathname === ''
      ? '/console'
      : location.pathname.replace(/\/+$/, ''),
  );

  useEffect(() => {
    setCurrentPath(
      location.pathname === '/' || location.pathname === ''
        ? '/console'
        : location.pathname.replace(/\/+$/, ''),
    );
  }, [location.pathname]);

  const handleGoHome = () => {
    navigate(isPlatform ? '/platform/clients' : '/console');
  };

  const Logo = collapsed ? WL_CONFIG.logo.small : WL_CONFIG.logo.medium;
  const trigger = useMemo(() => {
    const Trigger = collapsed ? MenuUnfoldOutlined : MenuFoldOutlined;
    return (
      <div
        className={`flex items-center justify-${collapsed ? 'center' : 'start'} h-full`}
        style={sidebarTrigger(collapsed)}
      >
        <Trigger style={sidebarTriggerIcon} />
      </div>
    );
  }, [collapsed]);

  const onSelectMenu = (e) => {
    // Check if the menu item has a custom onClick handler
    const menuConfig = itemsMap[e.key];
    
    if (menuConfig?.onClick) {
      // Execute custom onClick handler
      menuConfig.onClick(e);
    }
    
    // Always perform default navigation behavior
    setCurrentPath(e.key);
    navigate(e.key);
  };

  return (
    <Layout.Sider
      className="app-sidebar"
      style={{ ...sidebar, ...style }}
      width={240}
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      trigger={trigger}

    >
      <div style={sidebarTopContainer}>
        <div style={sidebarScrollableSection}>
          <div className="flex justify-start" style={{ ...sidebarLogo, position: 'relative', flexShrink: 0 }}>
            {IS_CHRISTMAS_TIME && <Snowfall snowflakeCount={8} style={{ marginTop: -15 }} />}
            <Logo onClick={handleGoHome} style={{ width: collapsed ? 30 : 150 }} />
          </div>

          {!isPlatform && (
            <SelectOrganization collapsed={collapsed} setCollapsed={setCollapsed} />
          )}
          {isPlatform && !collapsed && (
            <div style={{ padding: '8px 16px', fontWeight: 600, color: '#555', flexShrink: 0 }}>
              Platform
            </div>
          )}
          <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
            <Menu
              style={sidebarItemsContainer}
              selectedKeys={[
                currentPath.startsWith('/platform/clients')
                  ? '/platform/clients'
                  : currentPath,
              ]}
              onClick={onSelectMenu}
              mode="inline"
              className={`top-sidebar-menu ${collapsed ? 'collapsed' : ''}`}
              openKeys={openKeys}
              onOpenChange={setOpenKeys}
              items={topItems}
            />
          </div>
        </div>
        <Menu
          style={{ ...sidebarItemsContainer, ...sidebarBottomMenu }}
          defaultSelectedKeys={['']}
          selectedKeys={[currentPath]}
          mode="inline"
          onClick={onSelectMenu}
          className="bottom-sidebar-menu"
          items={bottomItems}
        />
      </div>
    </Layout.Sider>
  );
}

export default Sidebar;
